import axiosAgsc from "@/store/axiosAgsc";
const resource = "/Alarm";

export default {
  getAlarmsWithDetail: (payload: any = {}): any => {
    return axiosAgsc.post(`${resource}/GetAlarmsWithDetail`, payload);
  },
  updateAlarmStatuses: (payload: any = {}): any => {
    return axiosAgsc.put(`${resource}/UpdateAlarmStatuses`, payload);
  },  
  UpdateConditionStatus: (payload: any = {}): any => {
    return axiosAgsc.put(`${resource}/UpdateConditionStatus`, payload);
  },  
};
